module.exports = __webpack_public_path__ + "static/assets/868ab27113a856134dccc46672769574.svg";